import { getPropByPlatType } from '@/components/PlatformList/components/labelIcon/index'
import {
    DOUYIN_PLATFORM_KEY,
    KUAISHOU_PLATFORM_KEY,
    PDD_PLATFORM_KEY,
    TAOBAO_PLATFORM_KEY
} from '@/modules/globals/constants/platform/basics'

export const PERFECT_TYPE_ALL = 'ALL'
export const PERFECT_TYPE_PDD = 'Pinduoduo'
export const PERFECT_TYPE_DY = 'douyin'
export const PERFECT_TYPE_KS = 'kuaishou'
export const PERFECT_TYPE_TB = 'taobao'

export const FAIL_TYPE_ALL = 'ALL_shelves_fail'
export const FAIL_TYPE_PDD = 'Pinduoduo_shelves_fail'
export const FAIL_TYPE_DY = 'douyin_shelves_fail'
export const FAIL_TYPE_KS = 'kuaishou_shelves_fail'
export const FAIL_TYPE_TB = 'taobao_shelves_fail'

export const FAIL_TYPE_END = '_shelves_fail'

// 	任务状态, READY - 可以开始运行; RUNNING - 运行中; FINISHED - 运行完成;
export const TASK_STATUS_READY = 'READY'
export const TASK_STATUS_RUNNING = 'RUNNING'
export const TASK_STATUS_FINISHED = 'FINISHED'

export const OPTION_TYPE_PERFECT = 'PERFECT' // 已过期
export const OPTION_TYPE_FAIL = 'FAIL' //  上架失败

// 这里设计师说只有 上架失败 / 过期资料在用, 不是通用 icon, 不适合放在 platfrom 文件里
const allIconObj = {
    icon: 'https://assets.sursung.com/activity/20240619/B97309032F1D4D94804712D3E4F5E6DC1718767357689.png',
    label: '全部',
    name: '全部',
    type: 'ALL',
    value: ['ALL'],
    valueLetter: 'all'
}

export const PERFECT_TYPE_OPTION = [
    {
        key: FAIL_TYPE_ALL,
        text: '全部',
        iconObj: allIconObj,
        group: OPTION_TYPE_PERFECT
    },
    {
        key: FAIL_TYPE_DY,
        text: '抖音',
        iconObj: getPropByPlatType(DOUYIN_PLATFORM_KEY),
        group: OPTION_TYPE_PERFECT,
        platform: DOUYIN_PLATFORM_KEY
    },
    {
        key: FAIL_TYPE_KS,
        text: '快手',
        iconObj: getPropByPlatType(KUAISHOU_PLATFORM_KEY),
        group: OPTION_TYPE_PERFECT,
        platform: KUAISHOU_PLATFORM_KEY
    },
    {
        key: FAIL_TYPE_PDD,
        text: '拼多多',
        iconObj: getPropByPlatType(PDD_PLATFORM_KEY),
        group: OPTION_TYPE_PERFECT,
        platform: PDD_PLATFORM_KEY
    },
    {
        key: FAIL_TYPE_TB,
        text: '淘宝',
        iconObj: getPropByPlatType(TAOBAO_PLATFORM_KEY),
        group: OPTION_TYPE_PERFECT,
        platform: TAOBAO_PLATFORM_KEY
    },
    {
        key: PERFECT_TYPE_ALL,
        text: '全部',
        iconObj: allIconObj,
        group: OPTION_TYPE_FAIL,
        defaultChoose: true
    },
    {
        key: PERFECT_TYPE_DY,
        text: '抖音',
        iconObj: getPropByPlatType(DOUYIN_PLATFORM_KEY),
        group: OPTION_TYPE_FAIL,
        platform: DOUYIN_PLATFORM_KEY
    },
    {
        key: PERFECT_TYPE_KS,
        text: '快手',
        iconObj: getPropByPlatType(KUAISHOU_PLATFORM_KEY),
        group: OPTION_TYPE_FAIL,
        platform: KUAISHOU_PLATFORM_KEY
    },
    {
        key: PERFECT_TYPE_PDD,
        text: '拼多多',
        iconObj: getPropByPlatType(PDD_PLATFORM_KEY),
        group: OPTION_TYPE_FAIL,
        platform: PDD_PLATFORM_KEY
    },
    {
        key: PERFECT_TYPE_TB,
        text: '淘宝',
        iconObj: getPropByPlatType(TAOBAO_PLATFORM_KEY),
        group: OPTION_TYPE_FAIL,
        platform: TAOBAO_PLATFORM_KEY
    }
]
